import React from 'react';
import {
  Box,
  CloseIcon,
  HorizontalDivider,
  theme,
  TransparentButton,
  Typography,
  WarningIcon,
} from '@ttx/design-system';

interface MaxPurchaseWarningModalProps {
  onClose: () => void;
}

export const MaxPurchaseWarningModal: React.FC<
  MaxPurchaseWarningModalProps
> = ({onClose}: MaxPurchaseWarningModalProps) => {
  return (
    <Box
      w="100%"
      maxWidth={588}
      minWidth={['inherit', 588]}
      borderColor="outlines"
      borderWidth="one"
      borderStyle="solid"
    >
      <Box
        paddingX="md"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box flexDirection="row" alignItems="center">
          <WarningIcon size={12} />
          <Box ml="two">
            <Typography color="textDefault" textStyle="s">
              Limit Reached
            </Typography>
          </Box>
        </Box>
        <TransparentButton onPress={onClose} style={{padding: theme.space.md}}>
          <CloseIcon size={18} />
        </TransparentButton>
      </Box>
      <HorizontalDivider />
      <Box paddingX="md" paddingY="lg">
        <Typography textStyle="s" color="textDefault">
          {/* The maximum amount of NFTs you can own from this collection is 5.
          Please check the amount you&apos;re buying and make sure it&apos;s not
          more than 5 in total. */}
          Maximum quantity reached.
        </Typography>
        <Box mt="md" />
      </Box>
      <HorizontalDivider />
      <TransparentButton onPress={onClose}>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          paddingY="s"
        >
          <Typography textStyle="s" color="textDefault">
            Got it
          </Typography>
        </Box>
      </TransparentButton>
    </Box>
  );
};
